<ion-row class="tna-header">
  <ng-content></ng-content>
  <ion-col>
    <ion-row *ngIf="paginationInfo && paginationOption" class="ion-justify-content-end">
      <monorepo-listing-pagination
        [renderType]="'TNA'"
        [paginationInfo]="paginationInfo"
        [paginationOption]="paginationOption"
        (updateUserPaginationTuple)="updateUserPagination($event)"
      >
      </monorepo-listing-pagination>
    </ion-row>
  </ion-col>
  <ion-col size="auto">
    <ion-row>
      <ng-container *ngFor="let tool of toolbarActions">
        <ng-container *ngIf="tool === 'SHIFT_FILTER'">
          <span class="options factory-filter" (click)="onToolbarAction.emit([tool, $event])">
            <img class="default" src="assets/common/timeline/shift-filter-default.svg" />
            <img class="hover" src="assets/common/timeline/shift-filter-hover.svg" />
            <span class="hover hover-text"> Shift </span>
          </span>
        </ng-container>
        <ng-container *ngIf="tool === 'FACTORY_FILTER'">
          <span class="options factory-filter" (click)="onToolbarAction.emit([tool, $event])">
            <img class="default" src="assets/common/timeline/factory-filter-default.svg" />
            <img class="hover" src="assets/common/timeline/factory-filter-hover.svg" />
            <span class="hover hover-text"> Factory </span>
          </span>
        </ng-container>
        <ng-container *ngIf="tool === 'LOAD_ORDER'">
          <span class="options" (click)="onToolbarAction.emit([tool, $event])">
            <img class="default" src="assets/common/timeline/load-order-default.svg" />
            <img class="hover" src="assets/common/timeline/load-order-hover.svg" />
            <span class="hover hover-text"> Load Order </span>
          </span>
        </ng-container>
        <ng-container *ngIf="tool === 'MATERIAL_IN_HOUSE_UPLOAD'">
          <span class="options" (click)="onToolbarAction.emit([tool, $event])">
            <img class="default" src="assets/common/timeline/load-order-default.svg" />
            <img class="hover" src="assets/common/timeline/load-order-hover.svg" />
            <span class="hover hover-text"> Material In-House Upload </span>
          </span>
        </ng-container>
        <ng-container *ngIf="tool === 'SYNC'">
          <span class="options" (click)="onToolbarAction.emit([tool, $event])">
            <img class="default" src="assets/common/timeline/refresh-default.svg" />
            <img class="hover" src="assets/common/timeline/refresh-hover.svg" />
            <span class="hover hover-text"> Sync </span>
          </span>
        </ng-container>
        <ng-container *ngIf="tool === 'RECALIBERATE'">
          <span class="options" (click)="onToolbarAction.emit([tool, $event])">
            <img class="default" src="assets/common/timeline/recaliberate-default.svg" />
            <img class="hover" src="assets/common/timeline/recaliberate-hover.svg" />
            <span class="hover hover-text"> Recalibrate </span>
          </span>
        </ng-container>
        <ng-container *ngIf="tool === 'TASK_MANAGER'">
          <span class="options" (click)="onToolbarAction.emit([tool, $event])">
            <img class="default" src="assets/common/timeline/task-manager-default.svg" />
            <img class="hover" src="assets/common/timeline/task-manager-hover.svg" />
            <span class="hover hover-text"> Task Manager </span>
          </span>
        </ng-container>
        <ng-container *ngIf="tool === 'LINE_PLAN'">
          <span class="options" (click)="onToolbarAction.emit([tool, $event])">
            <img class="default" src="assets/common/timeline/line-plan-default.svg" />
            <img class="hover" src="assets/common/timeline/line-plan-hover.svg" />
            <span class="hover hover-text"> Line Plan </span>
          </span>
        </ng-container>
        <ng-container *ngIf="tool === 'PRINT'">
          <span class="options" (click)="print()">
            <img class="default" src="assets/common/timeline/print-default.svg" />
            <img class="hover" src="assets/common/timeline/print-hover.svg" />
            <span class="hover hover-text"> Print </span>
          </span>
        </ng-container>
        <ng-container *ngIf="tool === 'FILTERS'">
          <span [ngClass]="{ options: true, active: isFilterActive }" (click)="openFilter.emit()">
            <img class="default" src="assets/common/timeline/filter-default.svg" />
            <img class="hover" src="assets/common/timeline/filter-hover.svg" />
            <span class="hover hover-text"> Filter </span>
          </span>
        </ng-container>
        <ng-container *ngIf="tool === 'SEARCH'">
          <span class="options" (click)="onToolbarAction.emit(['SEARCH', $event])">
            <img class="default" src="assets/common/timeline/search-default.svg" />
            <img class="hover" src="assets/common/timeline/search-hover.svg" />
            <span class="hover hover-text"> &#8984; + K </span>
          </span>
        </ng-container>
        <ng-container *ngIf="tool === 'MORE'">
          <span class="options" (click)="onToolbarAction.emit([tool, $event])">
            <img class="default" src="assets/common/timeline/more-actions.svg" />
            <img class="hover" src="assets/common/timeline/more-actions-hover.svg" />
            <span class="hover hover-text"> More </span>
          </span>
        </ng-container>
        <ng-container *ngIf="tool === 'SYNC_IN_PROGRESS'">
          <span class="options">
            <img class="default" src="assets/common/timeline/refresh-hover-animated.svg" />
            <img class="hover" src="assets/common/timeline/refresh-hover-animated.svg" />
            <span class="hover hover-text"> Sync In Progress </span>
          </span>
        </ng-container>
      </ng-container>
    </ion-row>
  </ion-col>

  <ion-col size="auto" class="theme-view-column">
    <ng-container *ngIf="_timelineModel.boardView.themeView; else defaultView">
      <ion-button (click)="onTimelineView.emit($event)" fill="clear" class="theme-view-button">
        {{ _timelineModel.boardView.themeView.displayName }}
        <ion-icon name="caret-down-sharp" slot="end"></ion-icon>
      </ion-button>
    </ng-container>
    <ng-template #defaultView> Timeline View </ng-template>
  </ion-col>
  <ion-col size="auto">
    <ion-select
      class="ion-text-left"
      [value]="timelineView"
      (ionChange)="changeTimelineView($event)"
      interface="popover"
    >
      <ion-select-option *ngIf="configuration.renderType === 'LL_BOARD'" value="DAILY"> Daily </ion-select-option>
      <ion-select-option value="WEEKLY"> Weekly </ion-select-option>
      <ion-select-option value="MONTHLY"> Monthly </ion-select-option>
    </ion-select>
  </ion-col>

  <ion-col size="auto" *ngIf="!hideOpenInfoBtn">
    <ion-button class="info" (click)="openInfo.emit($event)">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20ZM9 5H11V7H9V5ZM12 15H8V13H9V11H8V9H11V13H12V15Z"
          fill="#0F31A9"
        />
      </svg>
    </ion-button>
  </ion-col>
</ion-row>

<div class="navigation">
  <div class="navigation__item item__today" *ngIf="!hideLeftPanel">
    <ion-button (click)="onToday.emit(_timelineModel.boardView)">
      <ion-icon name="today-sharp"></ion-icon>
      Today
    </ion-button>
  </div>

  <div class="navigation__item item__prev" [style.left]="hideLeftPanel ? '0px' : '150px'">
    <ion-button [disabled]="_timelineModel.disable?.prev" (click)="onPrev.emit(_timelineModel.boardView)">
      <ion-icon name="chevron-back-circle-outline"></ion-icon>
    </ion-button>
    <ion-icon
      [style]="{ color: _markers.indicatorMarkers.left?.color }"
      *ngIf="_markers.indicatorMarkers && _markers.indicatorMarkers.left?.isVisible"
      name="play-back-outline"
    ></ion-icon>
  </div>

  <div class="navigation__item item__next">
    <ion-button [disabled]="_timelineModel.disable?.next" (click)="onNext.emit(_timelineModel.boardView)">
      <ion-icon name="chevron-forward-circle-outline"></ion-icon>
    </ion-button>
    <ion-icon
      [style]="{ color: _markers.indicatorMarkers.right?.color }"
      *ngIf="_markers.indicatorMarkers && _markers.indicatorMarkers.right?.isVisible"
      name="play-forward-outline"
    ></ion-icon>
  </div>
</div>
<div class="timeline" #timeline></div>
